import { Form_BooleanInput } from '../../components/form/inputs/Form_BooleanInput';
import { Form_ColorInput } from '../../components/form/inputs/Form_ColorInput';
import { Form_EnumInput } from '../../components/form/inputs/Form_EnumInput';
import { Form_MultilineStringInput } from '../../components/form/inputs/Form_MultilineStringInput';
import { Form_MultiSelectCreatableInput } from '../../components/form/inputs/Form_MultiSelectCreatableInput';
import { Form_MultiSelectReferenceInput } from '../../components/form/inputs/Form_MultiSelectReferenceInput';
import { Form_NumberInput } from '../../components/form/inputs/Form_NumberInput';
import { Form_NumericInput } from '../../components/form/inputs/Form_NumericInput';
import { Form_ReferenceInput } from '../../components/form/inputs/Form_ReferenceInput';
import { Form_SecretInput } from '../../components/form/inputs/Form_SecretInput';
import { Form_SelectInput } from '../../components/form/inputs/Form_SelectInput';
import { Form_StringInput } from '../../components/form/inputs/Form_StringInput';
import { MultiSelectInput } from '../../components/form/inputs/MultiSelectInput';

export const Inputs = {
    Enum: Form_EnumInput,
    Number: Form_NumberInput,
    Reference: Form_ReferenceInput,
    MultiSelectReference: Form_MultiSelectReferenceInput,
    MultiSelectCreatable: Form_MultiSelectCreatableInput,
    String: Form_StringInput,
    Boolean: Form_BooleanInput,
    MultilineString: Form_MultilineStringInput,
    Numeric: Form_NumericInput,
    Select: Form_SelectInput,
    Secret: Form_SecretInput,
    Color: Form_ColorInput,
    MultiSelect: MultiSelectInput.Form,
    // RichText: Form_RichText,
};
